/**
 * Gestion du menu sur mobile et bureau
 * Ouverture du dropdown sous l'element de menu
 */

import * as Utils from './utils'

export default class MainMenu {
    constructor() {
        this.$offscreenNavContainer;
        this.$offscreenNavContainerInner;

        this.$body = document.body;
        this.$header = document.querySelector('#brx-header');

        this.$navMainContainer = document.querySelector('[data-role="main-menu"]');
        this.$navSecondaryContainer = document.querySelector('[data-role="secondary-menu"]');

        this.$navMain = this.$navMainContainer.querySelector('.brxe-nav-menu');
        this.$navSecondary = this.$navSecondaryContainer.querySelector('.brxe-nav-menu');

        this.$navMainDefaultDomPosition = this.$navMainContainer;
        this.$navSecondaryDefaultDomPosition = this.$navSecondaryContainer;

        this.$toggleMenuBtn = document.querySelector('[data-role="toggle-menu"]');
        this.$dropdowns = this.$header.querySelectorAll('.sub-menu');
        
        this.$navLinks = this.$header.querySelectorAll('.brx-submenu-toggle a');

        this.isOpen = false;
        this.menuBreakpoint = 'lg';
        this.initSmall = false;
        this.initLarge = false;

        this.closeListener = this._onClose.bind(this);
        this.linksClickedListener = this._onLinksClicked.bind(this);
        this.bodyClickListener = this._onBodyClicked.bind(this);

        this._init();
    }

    _init() {
        /**
         * Evenements commun
         */
        this._addEvents();

        /**
         * petite resolution
         */
        // suivant si on se trouve sur une grande resolution ou non les evenements different
        if (window.matchMedia('(max-width: '+ Utils.getBreakpoint(this.menuBreakpoint) +'px)').matches) {
            this._addEventSmallScreen();

        /**
         * grande resolution
         */
        } else {
            this._addEventLargeScreen();
        }
    }

    _createOffscreenNavContainer() {
        this.$offscreenNavContainer = document.createElement('div');
        this.$offscreenNavContainer.classList.add('offscreen-nav-container');
        this.$offscreenNavContainerInner = document.createElement('div');
        this.$offscreenNavContainerInner.classList.add('offscreen-nav-container__inner');
        this.$offscreenNavContainer.append(this.$offscreenNavContainerInner);
        this.$body.append(this.$offscreenNavContainer);
    }

    _addEvents() {
        window.addEventListener('resize', () => {
            if( window.matchMedia('(max-width: '+ Utils.getBreakpoint(this.menuBreakpoint) +'px)').matches) {
                // smallcreen
                if (this.initLarge) {
                    this._removeEventLargeScreen();
                    this._addEventSmallScreen();
                }
            } else {
                // largeScreen
                if (this.initSmall) {
                    this._removeEventSmallScreen();
                    this._addEventLargeScreen();
                }
            }
        });

        /**
         * ajout des evenements sur les liens
         */
        for(let $links of this.$navLinks) {
            $links.addEventListener("click", this.linksClickedListener);
        }

        //on active les boutons d'ouvertures et fermeture de la nav
        this.$toggleMenuBtn.addEventListener("click", this._toggleNavContainer.bind(this));
    }

    _addEventSmallScreen() {
        
        //on verifie si le menu est deja actif en version largeScreen auquel cas on supprime les evenements liés
        if(this.initLarge) {
            this._removeEventLargeScreen();
        }

        if(!this.initSmall) {
            // creation du container offscreen qui accueillera la nav
            if (!this.$offscreenNavContainer) {
                this._createOffscreenNavContainer();
            }

            // on deplace la nav principale dans le container offscreen
            this.$offscreenNavContainerInner.append(this.$navMain);

            // on deplace la nav secondaire dans le container offscreen
            this.$offscreenNavContainerInner.append(this.$navSecondary);

            // on clone l'entree du menu principale si celle-ci a un sous-menu
            // on ajoute l'entreé principale dans le dropdown
            this.$dropdowns.forEach($dropdown => {
                if (!$dropdown.querySelector('.is-clone')) {
                    let newElt = document.createElement('li');
                    newElt.classList.add('menu-item','bricks-menu-item','is-clone');

                    let cloneEntry = $dropdown.parentElement.getElementsByTagName('a')[0].cloneNode(true);
                    newElt.append(cloneEntry);
                    
                    $dropdown.prepend(newElt);
                }
            });

            this.initSmall = true;
        }
    }

    _addEventLargeScreen() {
        //on verifie si le menu est deja actif en version smallScreen
        if(this.initSmall) {
            this._removeEventSmallScreen();
        }

        if(!this.initLarge) {
            this.initLarge = true;
        }
    }

    _removeEventSmallScreen() {
        // on replace le conteneur de la nav principale à sa position initiale
        this.$navMainDefaultDomPosition.after(this.$navMain);

        // on replace la nav secondaire à sa position initiale
        this.$navSecondaryDefaultDomPosition.append(this.$navSecondary);

        //on retire les evenement
        for(let $links of this.$navLinks) {
            $links.removeEventListener("click", this.linksClickedListener);
        }
        this.$body.removeEventListener('click', this.bodyClickListener);

        this.$body.classList.remove('no-scroll');

        // supression des entrées clonées
        this.$dropdowns.forEach($dropdowns => {
            const $clones = $dropdowns.querySelectorAll('.is-clone');
            if ($clones) {
                $clones.forEach(($clone) => {
                    $clone.remove();
                })
            }

        })

        //fermeture de la nav offscreen
        if(this.$offscreenNavContainer.classList.contains('is-open'))
            this.close(true);

        this.initSmall = false;
    }

    _removeEventLargeScreen() {

        this.initLarge = false;
    }

    _onBodyClicked(e) {
        setTimeout(() => {
            const $parentElements = Utils.getParents(e.target, document.body);
            let isOffscreenNavChild = false;
            Array.from($parentElements).forEach(($elt) => {
                if ($elt.classList.contains('offscreen-nav-container')) {
                    isOffscreenNavChild = true;
                }
            })
            if (!isOffscreenNavChild) this.close();
        })
    }

    _onLinksClicked(e) {

        // peripherique tactile
        if (e.pointerType === 'touch') {
            const $parent = e.currentTarget.parentElement;

            //on verifie si le li contient un dropdown auquel cas on empeche le clic de s'effectuer
            //et on affiche le dropdown
            if( $parent.classList.contains("brx-submenu-toggle") ) {
                e.preventDefault();
            }
        }
    }

    

    _toggleNavContainer() {
        if(this.$offscreenNavContainer.classList.contains('is-open')) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.$toggleMenuBtn.classList.add('is-active');
        this.$offscreenNavContainer.classList.add('is-visible');

        // pour chaque dropdown on calcule sa hauteur qu'on stocke dans une variable pour effectuer une transition a l'ouverture
        this.$dropdowns.forEach($dropdown => {
            // calcul de la hauteur globale de $dropdown en fonction de ses enfants
            let height = 0;
            Array.from($dropdown.children).forEach($child => {
                height += $child.getBoundingClientRect().height;
            });
            $dropdown.style.setProperty('--max-height', height + 'px');
        });

        setTimeout(() => {
            this.$offscreenNavContainer.classList.add('is-open');
            // au clic en dehors de la nav elle se referme
            this.$body.addEventListener('click', this.bodyClickListener);
        });

        Utils.preventScroll(true);

        this.isOpen = true;
    }

    close(noTransition) {
        console.log('_close')
        this.$offscreenNavContainer.classList.remove('is-open');
        this.$toggleMenuBtn.classList.remove('is-active');
        Utils.preventScroll(false);

        // on bloque la propagation des transition enfants
        Array.from(this.$offscreenNavContainer.children).forEach($child => {
            $child.addEventListener('transitionend', function(e) {
                e.stopPropagation();
            });
        })

        if (noTransition) {
            this._onClose();
        } else {
            console.log(this.$offscreenNavContainer)
            this.$offscreenNavContainer.addEventListener('transitionend', this.closeListener);
        }
    }

    _onClose() {
        this.$offscreenNavContainer.classList.remove('is-visible');
        this.$offscreenNavContainer.removeEventListener('transitionend', this.closeListener);
        
        // au clic en dehors de la nav elle se referme
        this.$body.removeEventListener('click', this.bodyClickListener);

        this.isOpen = false;
    }
}